import styled from "styled-components";

import { windowWidth } from "@styles/global";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.secondary};
  color: white;
  padding: 15px;
  border-radius: 5px;
  opacity: 90%;

  :hover {
    opacity: 100%;
  }

  @media (min-width: ${windowWidth.tablet}) {
    cursor: pointer;
  }
`;
